import React from 'react'

import { useAuth } from '../../../lib/auth'
import LoginLink from '../../global/LoginLink'
import RegistrationLink from '../../global/RegistrationLink'
import { cn } from '../../utils/cn'

interface LibraryHeaderProps {
  className?: string
}

export const LibraryHeader: React.FC<LibraryHeaderProps> = ({ className }) => {
  const { isAuthenticated } = useAuth()

  return (
    <div
      className={cn(
        'flex flex-col md:flex-row max-w-screen-[1440px] mx-auto px-6 py-8 md:items-start lg:items-center md:justify-between gap-4',
        className,
      )}
    >
      <div className="items-baseline w-fit">
        <h1 className="flex md:hidden flex-col text-[40px] text-brand-navy font-medium">
          Resources
        </h1>
        <h1 className="hidden md:flex flex-col text-[40px] lg:text-6xl font-light text-brand-navy leading-none">
          <span className="font-medium">Resource</span> Library
        </h1>
      </div>

      <div className="flex flex-col lg:!flex-row w-full md:w-[75%] md:gap-4">
        <div className="">
          <b>Welcome to the Designs for Health Educational Resources.</b>
          {!isAuthenticated ? (
            <p className="mt-2 text-sm text-gray-600 max-w-3xl">
              Looking for more? Login to your professional account or create a new account to access
              product technical sheets, protocols, webinars and more.
            </p>
          ) : (
            <p className="mt-2 text-sm text-gray-600 max-w-3xl">
              Browse our library of science-based materials designed to support clinical excellence
              and ongoing learning. Many resources—like technical sheets, protocols, and
              webinars—are exclusive to registered practitioners, but all are welcome to explore
              what&#39;s available.
            </p>
          )}
        </div>
        {!isAuthenticated && (
          <div className="mt-6 lg:mt-0 flex lg:justify-end space-x-4 items-center">
            <LoginLink className="font-gotham px-5 py-2 bg-brand-orange text-white h-fit">
              Login
            </LoginLink>
            <RegistrationLink className="font gotham p-2 text-brand-orange h-fit">
              Create an account
            </RegistrationLink>
          </div>
        )}
      </div>
    </div>
  )
}
